import React from 'react';

function formatDate(d) {
  if (!d) return '—';
  const dt = new Date(d);
  return isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString();
}

function UserList({ users = [] }) {
  return (
    <div className="mes-produits-container">{/* wrapper standard */}
      <div className="mes-produits-header">
        <h2>Liste des Utilisateurs</h2>
      </div>

      {!users.length ? (
        <p className="empty-state">Aucun utilisateur.</p>
      ) : (
        <div className="table-responsive">
          <table className="users-table">
            {/* largeur contrôlée des colonnes (ID étroit, téléphone un peu étroit) */}
            <colgroup>
              <col style={{ width: '80px' }} />
              <col />
              <col />
              <col />
              <col style={{ width: '160px' }} />
              <col />
              <col style={{ width: '140px' }} />
            </colgroup>

            <thead>
              <tr>
                <th>#ID</th>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Email</th>
                <th>Téléphone</th>
                <th>Adresse</th>
                <th>Inscrit le</th>
              </tr>
            </thead>

            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td data-label="#ID">{u.id}</td>
                  <td data-label="Nom">{u.nom || '—'}</td>
                  <td data-label="Prénom">{u.prenom || '—'}</td>
                  <td data-label="Email">{u.email || '—'}</td>
                  <td data-label="Téléphone">{u.telephone || '—'}</td>
                  <td data-label="Adresse">{u.adresse || '—'}</td>
                  <td data-label="Inscrit le">{formatDate(u.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default UserList;
